import type { ReactNode } from "react";

interface EmptyArtifactStateProps {
  children: ReactNode;
}

// CEM artifact upload is a single deliberate action against one project's one
// CEM workbook (.xlsx/.xlsm) — there's no evidence-catalog equivalent to
// browse and no benefit to a drag/drop zone the way multi-file PDF evidence
// upload has one, so a single upload trigger (native file picker only) is
// enough. That trigger is the same self-contained <UploadCemModel /> used in
// the top-right action row once artifacts exist — passed in as children
// rather than reimplemented here, so there's exactly one owner of the
// upload/preview state regardless of which branch renders it.
const EmptyArtifactState = ({ children }: EmptyArtifactStateProps) => {
  return (
    <div className="flex flex-col items-center text-center max-w-xl mx-auto py-4">
      {children}
    </div>
  );
};

export default EmptyArtifactState;
